<!-- Modal Backdrop -->
<div class="modal fade show" id="revmodal" tabindex="-1" aria-labelledby="revModalLabel" aria-hidden="true"
  style="display: block;">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content p-4">
      <!-- Close Button -->
      <div class="d-flex justify-content-end" (click)="closePopup()">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <!-- Form -->
      <form method="post" id="review_submit" novalidate>
        <!-- Success Icon -->
        <div class="text-center">
          <div class="checkmark fs-1 text-success">
            <i class="fa-solid fa-check"></i>
          </div>
        </div>
        <!-- Title & Text -->
        <h2 class="h4 text-center mb-2 py-3">Hi!</h2>
        <p class="text-center">Your item has been added to your wish list.</p>
        <!-- Buttons -->
        <div class="text-center mt-3">
          <button type="button" class="btn btn-danger" data-bs-dismiss="modal" (click)="closePopup()">OK</button>
        </div>
      </form>
    </div>
  </div>
</div>